import { forwardRef, MouseEvent } from "react";
import { ReactComponent as DragIcon } from '../../../../assets/Icons/adornments/DragIndicator.svg';
import { ReactComponent as AddIcon } from '../../../../assets/Icons/adornments/Circle-Plus.svg';
import { ReactComponent as RemoveIcon } from '../../../../assets/Icons/adornments/Trash.svg';
import ColoredSelectFields, { ColorOption } from "../../../../components/Form/ColoredSelectFields";
import { TreeSelectedCategory } from "../../../../hooks/useModelFamilyTree";


interface SelectCategoryProps {
    id: string,
    index: number,
    selectedCategory: TreeSelectedCategory,
    allCategories?: ColorOption[],
    handleSelectCategory?: (e:any, name: string) => void,
    handleAddCategory?: () => void,
    handleRemoveCategory?: (id: string) => void,
    count?: number,
    style?: any,
    dragProps?: any,
}

export const SelectCategory = forwardRef<any, SelectCategoryProps>(({ 
    id,
    selectedCategory, 
    allCategories,
    handleSelectCategory,
    handleAddCategory,
    handleRemoveCategory,
    index,
    count,
    style, 
    dragProps,
 }, ref) => {

    const { value, label, color } = selectedCategory;

    const handleSelect = (e: any, name: string) => {
        if (!handleSelectCategory) return;

        handleSelectCategory(e, name);
    }

    return (
        <div
            ref={ref}
            style={style}
            className='w-full flex justify-start items-center gap-3'
        >
            {(count === undefined || count > 1) && (
            <div {...dragProps} className="shrink-0 w-[16px] text-outline hover:text-primary hover:cursor-move transition-all">
                <DragIcon />
            </div>
            )}
            <p className="shrink-0">{index + 1}</p>
            <div className="grow">
                <ColoredSelectFields 
                    id={id}
                    name={id}
                    value={value ? { value, label, color } : null}
                    options={allCategories ?? []}
                    handleChange={handleSelect}
                />
            </div>
            {handleAddCategory && count !== undefined && index === count - 1 && allCategories !== undefined && allCategories.filter(category => category.value !== '').length > 1 && (
                <button 
                    onClick={(e: MouseEvent<HTMLButtonElement>) => {
                        e.preventDefault();
                        handleAddCategory();
                    }}
                    className="shrink-0 w-[20px] text-disable hover:text-primary transition-all"
                >
                    <AddIcon />
                </button>
            )}

            {handleRemoveCategory && count !== undefined && count > 1 && (
                <button 
                    onClick={(e: MouseEvent<HTMLButtonElement>) => {
                        e.preventDefault();
                        handleRemoveCategory(id);
                    }}
                    className="shrink-0 w-[20px] text-disable hover:text-primary transition-all"
                >
                    <RemoveIcon />
                </button>
            )}

        </div>
    )
}) 